export default __webpack_public_path__ + "static/media/login.9a625095.png";